import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section className="w-full bg-gradient-radial pb-12 lg:py-28 ">
            <div className="container mx-auto px-4 lg:px-14 flex flex-col-reverse lg:flex-row md:space-x-10 items-center lg:items-start gap-5 md:gap-10">
                <div className="flex flex-col items-center lg:items-start text-center lg:text-left gap-5 md:gap-12 mt-3 md:mt-10">
                    <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold font-urbanist text-white capitalize text-center">
                        <div className='leading-snug'>Uniting & Uplifting India’s Fitness & Wellness Industry</div>
                    </h1>
                    <p className="text-sm sm:text-base lg:text-xl font-semibold text-[#D1D5DB] font-poppins leading-7">
                        National movement dedicated to empowering ethical, authentic, responsible and recognized
                        professionals in fitness & wellness.
                    </p>
                    <div className="w-full flex flex-col items-center font-inter lg:items-center text-center lg:text-left gap-8">
                        <Link to='/about'
                            className="px-8 py-3 bg-white rounded-[50px] text-neutral-950 text-lg sm:text-xl lg:text-3xl font-semibold font-inter leading-5 md:leading-10 hover:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow">
                            Know More
                        </Link>
                    </div>
                </div>
                <div className="w-full max-w-sm sm:max-w-md lg:max-w-lg mt-8 lg:mt-0">
                    <img className="w-full h-auto" src="/assets/india.png" alt="hero-image" />
                </div>
            </div>
        </section>
    );
};

export default HeroSection;